import { Image, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { getPdfLabelStyle, pdfStyles } from '../pdfStyles';
import { logo } from '../imgData';
import { ColorSet } from 'src/redux/reducers/theme';
import { useAuth } from 'src/state/auth';
import { useImageLightness } from 'src/hooks/useImageLightness';
import { normalizeHexColor } from 'src/utils/color';

interface FooterCompanyProps {
  companyName: string;
  title: string;
  companyImage?: string;
  label?: string;
  colors: ColorSet;
  logoSrc?: string;
  primaryColor?: string | null;
  secondaryColor?: string | null;
}

export const FooterCompany: React.FC<FooterCompanyProps> = ({
  colors,
  label,
  title,
  companyImage,
  logoSrc,
  primaryColor,
  secondaryColor,
}) => {
  const { profile } = useAuth();
  const resolvedLogo = logoSrc || profile?.activeOrganisation?.logoUrl || logo;
  const bannerColor = normalizeHexColor(primaryColor || profile?.activeOrganisation?.primaryColor) || colors.cultured;
  const customLogoSrc = logoSrc || profile?.activeOrganisation?.logoUrl;
  const logoIsLight = useImageLightness(customLogoSrc);
  const shouldShadowLogo = Boolean(customLogoSrc) && (logoIsLight ?? true);
  const labelStyle = getPdfLabelStyle(secondaryColor);
  const logoStyle = {
    width: 120,
    height: 43,
    left: 0,
    objectFit: 'contain',
    ...(shouldShadowLogo ? { border: '0.5px solid #D0D5DD', borderRadius: 4 } : {}),
  };

  return (
    <>
      <View style={{ backgroundColor: bannerColor, bottom: 0, position: 'absolute', width: '100%' }}>
        <View style={{ ...pdfStyles.section, paddingTop: 30, paddingBottom: 30 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Image src={resolvedLogo} style={logoStyle} />
            </View>
            {companyImage && (
              <View style={{ width: 120, marginRight: 5 }}>
                <View
                  style={{
                    width: 120,
                    height: 140,
                    backgroundColor: colors.white,
                    top: -70,
                    position: 'absolute',
                    padding: 10,
                  }}
                >
                  <View
                    style={{
                      border: `0.7px solid ${colors.gp1}`,
                      flex: 1,
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Image src={companyImage} style={{ width: '100%' }} />
                  </View>
                </View>
              </View>
            )}
          </View>

          <View style={{ ...pdfStyles.spacer32 }} />
          <View style={{ ...pdfStyles.spacer32 }} />
          <View>
            {label && <Text style={labelStyle}>{label}</Text>}
            <Text style={{ color: colors.prussianBlue, fontWeight: 600, fontSize: 22 }}>{title}</Text>
          </View>
        </View>
      </View>
      <View style={{ ...pdfStyles.spacer32 }} />
    </>
  );
};
